import * as React from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import { PanelMarker, BloodworkAnalysis, BloodworkNote, FurtherConsiderations, Section } from '../models';
import { FurtherConsiderationsSection } from './bloodworkz/further-considerations-section';
import { ReferenceRangeAnalysisContainer } from '../containers/bloodwork-ref-range-analysis-container';
import { BloodworkEntryStore } from '../stores/bloodwork-entry-store';
import { BloodworkNotes } from './bloodworkz/bloodwork-notes';

type Props = {
    section: Section;
    panelMarkers: PanelMarker[];
    bloodworkAnalysis: BloodworkAnalysis;
    furtherConsiderations: FurtherConsiderations;
    bloodworkEntryStore: BloodworkEntryStore;
    infoLink: string;
};

type State = {
    bloodworkNote: BloodworkNote;
};

export class TabsComponent extends React.Component<Props, {}> {
    state: State = {
        bloodworkNote: this.initBloodworkNote(this.props.section, this.props.bloodworkAnalysis),
    }

    componentWillReceiveProps(nextProps) {
        const { section, bloodworkAnalysis } = nextProps;
        this.setState({
            bloodworkNote: this.initBloodworkNote(section, bloodworkAnalysis),
        });
    }

    initBloodworkNote(section: string, bloodworkAnalysis: BloodworkAnalysis): BloodworkNote {
        if (bloodworkAnalysis && bloodworkAnalysis.bloodwork && bloodworkAnalysis.bloodwork.bloodworkNotes) {
            let bloodworkNote = bloodworkAnalysis.bloodwork.bloodworkNotes.findNote(section);
            if (!bloodworkNote) {
                bloodworkNote = bloodworkAnalysis.bloodwork.bloodworkNotes.addNote(section, '');
            } 
            return new BloodworkNote(bloodworkNote);
        }
        return new BloodworkNote(); 
    }

    handleInputChange = (event: any) => {
        const { section } = this.props;
        const value = event.target.value;
        this.setState({
            bloodworkNote: new BloodworkNote({section, text: value}),
        });
    }

    saveOrUpdate = (event: any) => {
        const { section, bloodworkAnalysis, bloodworkEntryStore } = this.props;
        event.preventDefault();
        const bloodworkNote = bloodworkAnalysis.bloodwork.bloodworkNotes.findNote(section);
        bloodworkNote.text = this.state.bloodworkNote.text;
        bloodworkEntryStore.saveBloodwork(bloodworkAnalysis.bloodwork);
    }

    showInsightsTab(): boolean {
        const { section } = this.props;
        return [
            Section.RBC, 
            Section.WBC].includes(section)
    }

    showPossibleRootCausesTab(): boolean {
        const { section } = this.props;
        return section !== Section.RBC;
    }

    showOtherTabs(): boolean {
        const { section } = this.props;
        return section === Section.RBC;
    }

    refRangeTitle(): string {
        const { section } = this.props;
        if (section === Section.WBC) {
            return 'Immune System Reference Range Analysis';
        } else if (section === Section.PLATELETS) {
            return 'Coagulation Reference Range Analysis';
        }
        return `${section} Reference Range Analysis`;
    }

    render() {
        const { section, bloodworkAnalysis, furtherConsiderations, panelMarkers, bloodworkEntryStore, infoLink } = this.props;
        
        return (
            <Tabs defaultActiveKey={1} id="uncontrolled-tab-example">
                <Tab eventKey={1} title="Reference Range">
                    <br />
                    <ReferenceRangeAnalysisContainer 
                        title={this.refRangeTitle()}
                        section={section}
                        bloodwork={bloodworkAnalysis.bloodwork}
                        infoLink={infoLink}
                        panelMarkers={panelMarkers} 
                    />
                </Tab>

                { this.showInsightsTab() ?
                    <Tab eventKey={2} title="Insights" >
                        <br />
                        <FurtherConsiderationsSection
                            section={section}
                            tab="Interpretation"
                            bloodworkAnalysis={bloodworkAnalysis}
                            furtherConsiderations={furtherConsiderations}
                        />
                    </Tab>
                    : null
                }

                { this.showPossibleRootCausesTab() ?
                    <Tab eventKey={3} title="Possible Root Causes" >
                        <br />
                        <FurtherConsiderationsSection
                            section={section}
                            tab="Causes"
                            bloodworkAnalysis={bloodworkAnalysis}
                            furtherConsiderations={furtherConsiderations}
                        />
                    </Tab>
                    : null
                }

                { this.showOtherTabs() ?
                    <Tab eventKey={4} title="Additional Testing">
                        <br />
                        <FurtherConsiderationsSection
                            section={section}
                            tab="Testing" 
                            bloodworkAnalysis={bloodworkAnalysis}
                            furtherConsiderations={furtherConsiderations}
                        />
                    </Tab>
                    : null
                }

                { this.showOtherTabs() ?
                    <Tab eventKey={5} title="Further Considerations">
                        <br />
                        <FurtherConsiderationsSection
                            section={section}
                            tab="Considerations" 
                            bloodworkAnalysis={bloodworkAnalysis}
                            furtherConsiderations={furtherConsiderations}
                        />
                    </Tab>
                    : null
                }
                
                { this.showOtherTabs() ?
                    <Tab eventKey={6} title="Signs and Symptoms">
                        <br />
                        <FurtherConsiderationsSection
                            section={section}
                            tab="Symptoms"
                            bloodworkAnalysis={bloodworkAnalysis}
                            furtherConsiderations={furtherConsiderations}
                        />
                    </Tab>
                    : null
                }

                { this.showOtherTabs() ?
                    <Tab eventKey={7} title="Diet">
                        <br />
                        <FurtherConsiderationsSection
                            section={section}
                            tab="Diet"
                            bloodworkAnalysis={bloodworkAnalysis}
                            furtherConsiderations={furtherConsiderations}
                        />
                    </Tab>
                    : null
                }

                { this.showOtherTabs() ?
                    <Tab eventKey={8} title="Lifestyle">
                        <br />
                        <FurtherConsiderationsSection
                            section={section}
                            tab="Lifestyle"
                            bloodworkAnalysis={bloodworkAnalysis}
                            furtherConsiderations={furtherConsiderations}
                        />
                    </Tab>
                    : null
                }

                <Tab eventKey={9} title="Notes">
                    <br />
                    <BloodworkNotes 
                        section={section}
                        title="Add your own notes related to this analysis here. Click Save when finished."
                        bloodwork={bloodworkAnalysis.bloodwork}
                        bloodworkEntryStore={bloodworkEntryStore}
                    />
                </Tab> 
                {/* <Tab eventKey={8} title="Supplements">
                    <br />
                    <FurtherConsiderationsSection
                        section={section}
                        tab="Supplements"
                        bloodworkAnalysis={this.props.bloodworkAnalysis}
                        furtherConsiderations={this.props.furtherConsiderations}
                    />
                </Tab> */}
            </Tabs>
        );
    }
}